<script lang="ts">
	import type { HTMLAttributes } from 'svelte/elements';

	let props: HTMLAttributes<SVGElement> = $props();
</script>

<svg viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
	<rect x="0.5" y="0.5" width="15" height="15" rx="7.5" stroke="currentColor" />
	<g clip-path="url(#clip0_17251_3019)">
		<mask
			id="mask0_17251_3019"
			style="mask-type:alpha"
			maskUnits="userSpaceOnUse"
			x="0"
			y="0"
			width="16"
			height="16"
		>
			<rect width="16" height="16" fill="currentColor" />
		</mask>
		<g mask="url(#mask0_17251_3019)">
			<path
				d="M6.66673 9.2832L10.7334 5.21654C10.8556 5.09431 10.9973 5.0332 11.1584 5.0332C11.3195 5.0332 11.4612 5.09431 11.5834 5.21654C11.7056 5.33876 11.7667 5.48043 11.7667 5.64154C11.7667 5.80265 11.7056 5.94431 11.5834 6.06654L7.0834 10.5665C6.96118 10.6888 6.81951 10.7499 6.6584 10.7499C6.49729 10.7499 6.35562 10.6888 6.2334 10.5665L4.41673 8.74987C4.29451 8.62765 4.2334 8.48598 4.2334 8.32487C4.2334 8.16376 4.29451 8.02209 4.41673 7.89987C4.53895 7.77765 4.68062 7.71654 4.84173 7.71654C5.00284 7.71654 5.14451 7.77765 5.26673 7.89987L6.66673 9.2832Z"
				fill="currentColor"
			/>
		</g>
	</g>
	<defs>
		<clipPath id="clip0_17251_3019">
			<rect width="16" height="16" fill="white" />
		</clipPath>
	</defs>
</svg>
